import React from 'react';

const CalculateButton = () => {
	return (
		<div className="form-group btn-group">
			<button className="btn btn-block">Calculate</button>
		</div>
	);
};

export default CalculateButton;
